import { BarcodeOutlined, FontSizeOutlined, MoreOutlined, PictureOutlined } from '@ant-design/icons';
import { Tree } from 'antd';
import { EventDataNode } from 'antd/es/tree';
import React, { useEffect, useState } from 'react';
import { VDOItem, VisualObjectsTreeNode } from '../../../model/BadgeModel';
import { MagStripeIcon, SignatureIcon } from '../../../resources/Icons';
import { WithCollapsible } from '../../common';
import styles from './visualDataObjects.module.scss';

type Props = {};

type NodeDragEvent<T = HTMLDivElement> = {
	event: React.DragEvent<T>;
	node: EventDataNode<VisualObjectsTreeNode>;
};

const visualDataObjectsIcons: Record<VDOItem, React.ReactElement> = {
	[VDOItem.Text]: <FontSizeOutlined className={styles.icon} />,
	[VDOItem.Picture]: <PictureOutlined className={styles.icon} />,
	[VDOItem.Signature]: <SignatureIcon className={styles.icon} />,
	[VDOItem.BarCode]: <BarcodeOutlined className={styles.icon} />,
	[VDOItem.MagStripe]: <MagStripeIcon className={styles.icon} />,
};

const component: React.FC<Props> = ({}) => {
	const [treeData, setTreeData] = useState<VisualObjectsTreeNode[]>([]);

	useEffect(() => {
		const newNodes: VisualObjectsTreeNode[] = [];

		for (let key in VDOItem) {
			const keyNumber = Number(key);
			if (!isNaN(keyNumber)) {
				newNodes.push({
					key: keyNumber,
					title: _(VDOItem[keyNumber]),
					switcherIcon: <MoreOutlined />,
					vdoItem: keyNumber,
					icon: visualDataObjectsIcons[keyNumber],
				});
			}
		}

		setTreeData(newNodes);
	}, []);

	const handleOnDragStart = (dragEvent: NodeDragEvent) => {
		const { event } = dragEvent;
		const dataNode = dragEvent.node as VisualObjectsTreeNode;

		const jsonString = JSON.stringify({ vdoItem: dataNode.vdoItem });

		event.dataTransfer.setData('custom-type', jsonString);
	};

	return (
		<div className={styles.container}>
			<Tree
				blockNode
				showIcon
				showLine={{ showLeafIcon: false }}
				draggable={{ icon: false }}
				onDragStart={handleOnDragStart}
				allowDrop={() => false}
				treeData={treeData}
				selectable={false}
			/>
		</div>
	);
};

const VisualDataObjects = WithCollapsible(component, `VDO - ${_('Enrollment')}`);

export { VisualDataObjects };
